module.exports = __webpack_public_path__ + "img/zhyl.8fb646d7.png";